import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { dynamicTextPlaceholder } from '@shared/enums';
import { DprDetails } from '@shared/models/dpr';
import { SubprojectConfigurationCustomNames } from '@shared/models/project-setup';
import { DprDetailsTimeFormat, DprLockDateFormat } from '@shared/utils';

@Component({
  selector: 'app-dpr-details-header',
  templateUrl: './dpr-details-header.component.html',
  styleUrls: ['./dpr-details-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprDetailsHeaderComponent {
  //#region Inputs

  @Input({ required: true }) dprDetails: DprDetails;
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;
  @Input({ required: true }) isHandset: boolean;

  //#endregion

  dprRevisionLabel = $localize`:@@dprDetails.dprDetailsHeader.lblRevision:Revision (---)`;
  dprLockedLabel = $localize`:@@dprDetails.dprDetailsHeader.lblLockedDate:Locked on (---)`;
  dprDetailsTimeFormat = DprDetailsTimeFormat;
  dprLockDateFormat = DprLockDateFormat;
  dynamicTextPlaceholder = dynamicTextPlaceholder;
}
